import { connect } from "react-redux";
import { getViewportCategory } from "../../../state/modules/layout/selectors";
import { getCategoryChildLinks } from "../../../state/modules/category";

import Pills from "./Pills";

const mapStateToProps = state => ({
  pills: getCategoryChildLinks(state),
  viewport: getViewportCategory(state)
});

export default connect(mapStateToProps)(Pills);
